// import "./productpageinfo.css";
// import { useState, useEffect, useRef } from 'react';
// import Addcomment from "./productpageaddcomment";
// import { useTranslation } from '../../hooks/useTranslation';
// import { useLanguage } from "../../context/LanguageContext";
// import { getImageUrl } from '../../utils/imageUtils';

// export default function Productpageinfo({ product, cartlist, setcartlist }) {
//     const { t, currentLanguage, direction } = useTranslation();
//     const { language } = useLanguage();
//     const imagesContainerRef = useRef(null);
//     const positionRef = useRef(0); // ← أضف هذا السطر

//     const [comments, setComments] = useState([]);
//     const [numberofbuttons, setNumberofbuttons] = useState(1);
//     const [commentsnum, setCommentsnum] = useState(0);
//     const [selectedButton, setSelectedButton] = useState(1);
//     const [selectedColor, setSelectedColor] = useState(null);
//     const [selectedSize, setSelectedSize] = useState(null);
//     const [currentPrice, setCurrentPrice] = useState("0 " + t('currency'));
//     const [isCurrentSizeValid, setIsCurrentSizeValid] = useState(false);
//     const [isAnimationPaused, setIsAnimationPaused] = useState(false);

//     // --- حالة الإشعارات ---
//     const [notification, setNotification] = useState({ message: '', type: '' });
//     const notificationTimeoutRef = useRef(null);

//     // --- دالة إظهار الإشعار المؤقت ---
//     const showNotification = (message, type = 'info') => {
//         if (notificationTimeoutRef.current) {
//             clearTimeout(notificationTimeoutRef.current);
//         }
//         setNotification({ message, type });
//         notificationTimeoutRef.current = setTimeout(() => {
//             setNotification({ message: '', type: '' });
//         }, 3000);
//     };

//     const productData = product || {
//         id: 1,
//         name: t('productName'),
//         global_price: t('price'),
//         description: t('productDescription'),
//         imgs: [],
//         colors_sizes: [],
//         comments: []
//     };

//     const hasColors = productData.colors_sizes && productData.colors_sizes.length > 0;

//     const hasSizes = () => {
//         if (!hasColors) return false;
//         if (selectedColor) {
//             return selectedColor.sizesAtColor && selectedColor.sizesAtColor.length > 0;
//         }
//         return productData.colors_sizes.some(color =>
//             color.sizesAtColor && color.sizesAtColor.length > 0
//         );
//     };

//     const productImages = Array.isArray(productData.images) ? productData.images : [];
//     const allImages = productImages.length > 0
//         ? productImages.map(img => getImageUrl(img))
//         : ['default-image.jpg'];

//     const displayImages = [...allImages, ...allImages];

//     const firstsevenbuttons = [1, 2, 3, 4, 5, 6, 7];
//     const lastsevenbuttons = [
//         (numberofbuttons - 6),
//         (numberofbuttons - 5),
//         (numberofbuttons - 4),
//         (numberofbuttons - 3),
//         (numberofbuttons - 2),
//         (numberofbuttons - 1),
//         numberofbuttons
//     ];

//     useEffect(() => {
//         const savedBtn = window.localStorage.ProductPageBtnSelected;
//         if (savedBtn) setSelectedButton(Number(savedBtn));
//     }, []);



//     const handleMouseEnter = () => {
//         setIsAnimationPaused(true);
//     };

//     const handleMouseLeave = () => {
//         setIsAnimationPaused(false);
//     };

//     const handleToggleAnimation = () => {
//         setIsAnimationPaused(prev => !prev);
//     };


//     // --- دالة إضافة المنتج (استبدال alert) ---
//     function addproductclicked() {
//         if (hasColors && !selectedColor) {
//             showNotification(t('selectColorFirst'), 'error');
//             return;
//         }
//         if (hasSizes() && !selectedSize) {
//             showNotification(t('selectSizeFirst'), 'error');
//             return;
//         }

//         const newProduct = {
//             id: product.id,
//             name: product.name || productData.name,
//             price: currentPrice,
//             color: selectedColor ? selectedColor.colorNameInArabic : "",
//             size: selectedSize || "",
//             quantity: 1,
//             uniqueId: `${product.id}_${selectedColor ? selectedColor.colorNameInArabic : 'no-color'}_${selectedSize || 'no-size'}`
//         };

//         const isProductAlreadyInCart = cartlist.some(item =>
//             item.uniqueId === newProduct.uniqueId
//         );

//         if (isProductAlreadyInCart) {
//             showNotification(t('productAlreadyInCart'), 'error');
//             return;
//         }

//         setcartlist(prevCart => {
//             const updatedCart = [...prevCart, newProduct];
//             localStorage.setItem('cart', JSON.stringify(updatedCart));
//             return updatedCart;
//         });

//         showNotification(t('productAddedToCart'), 'success');
//     }

//     useEffect(() => {
//         if (productData.comments && Array.isArray(productData.comments)) {
//             setComments(productData.comments);
//             setCommentsnum(productData.comments.length);
//             if (productData.comments.length % 10 === 0) {
//                 setNumberofbuttons(productData.comments.length / 10);
//             } else {
//                 setNumberofbuttons(Math.ceil(productData.comments.length / 10));
//             }
//         }
//     }, [productData]);

//     useEffect(() => {
//         if (hasColors && productData.colors_sizes[0].price) {
//             setCurrentPrice(productData.colors_sizes[0].price);
//         } else {
//             setCurrentPrice(productData.global_price || "0 " + t('currency'));
//         }
//     }, [productData]);

//     const handleColorChange = (colorItem) => {
//         setSelectedColor(colorItem);
//         if (colorItem.price) {
//             setCurrentPrice(colorItem.price);
//         } else if (productData.global_price) {
//             setCurrentPrice(productData.global_price);
//         }

//         if (colorItem.sizesAtColor && colorItem.sizesAtColor.length > 0) {
//             if (selectedSize && !colorItem.sizesAtColor.includes(selectedSize)) {
//                 setSelectedSize(null);
//                 setIsCurrentSizeValid(false);
//             } else if (selectedSize && colorItem.sizesAtColor.includes(selectedSize)) {
//                 setIsCurrentSizeValid(true);
//             }
//         } else {
//             setIsCurrentSizeValid(true);
//             setSelectedSize(null);
//         }
//     };

//     const handleSizeChange = (size) => {
//         setSelectedSize(size);
//         setIsCurrentSizeValid(true);
//     };

//     const isButtonDisabled = () => {
//         if (hasColors && !selectedColor) return true;
//         if (hasSizes() && !selectedSize) return true;
//         if (selectedColor && selectedSize) {
//             if (selectedColor.sizesAtColor && selectedColor.sizesAtColor.length > 0) {
//                 return !selectedColor.sizesAtColor.includes(selectedSize);
//             }
//         }
//         return false;
//     };

//     const getButtonText = () => {
//         if (hasColors && !selectedColor) return t('selectColorFirst');
//         if (hasSizes() && !selectedSize) return t('selectSizeFirst');
//         if (selectedColor && selectedSize && !isCurrentSizeValid) return t('invalidSizeForColor');
//         return t('addToCartButton');
//     };



//     useEffect(() => {
//         const container = imagesContainerRef.current;
//         if (!container) return;
//         let animationId;
//         const speed = 0.6;
//         let totalWidth = 0;
//         const updateTotalWidth = () => {
//             totalWidth = container.scrollWidth / 2;
//             if (totalWidth === 0) totalWidth = window.innerWidth * 0.8 * allImages.length;
//         };
//         const handleResize = () => {
//             updateTotalWidth();
//         };
//         updateTotalWidth();
//         const animate = () => {
//             if (totalWidth === 0) {
//                 updateTotalWidth();
//             }
//             if (!isAnimationPaused) {
//                 const sign = language === 'ar' ? 1 : -1;
//                 positionRef.current += speed; // ← استخدم positionRef.current بدلاً من position
//                 if (positionRef.current >= totalWidth) {
//                     positionRef.current -= totalWidth;
//                 }
//                 container.style.transform = `translateX(${sign * positionRef.current}px)`;
//             }
//             animationId = requestAnimationFrame(animate);
//         };
//         animate();
//         window.addEventListener('resize', handleResize);
//         return () => {
//             cancelAnimationFrame(animationId);
//             window.removeEventListener('resize', handleResize);
//         };
//     }, [allImages, language, isAnimationPaused]);



//     // --- دوال التعليقات والأزرار (بدون تغيير) ---
//     function Controlcomments() {
//         function Makebuttons() {
//             const handleButtonClick = (buttonId) => {
//                 setSelectedButton(buttonId);
//                 window.localStorage.ProductPageBtnSelected = buttonId;
//             };

//             const buttons = [];

//             if (numberofbuttons <= 15) {
//                 for (let i = 1; i <= numberofbuttons; i++) {
//                     buttons.push(
//                         <div className="control-section-button" id={`control-section-button-${i}`} key={i}>
//                             <button
//                                 className={`button-${selectedButton === i ? 'selected' : ''}`}
//                                 onClick={() => handleButtonClick(i)}
//                             >{i}</button>
//                         </div>
//                     );
//                 }
//             } else {
//                 if (firstsevenbuttons.includes(selectedButton)) {
//                     for (let i = 1; i <= 15; i++) {
//                         if (i < 14) {
//                             buttons.push(
//                                 <div className="control-section-button" id={`control-section-button-${i}`} key={i}>
//                                     <button
//                                         className={`button-${selectedButton === i ? 'selected' : ''}`}
//                                         onClick={() => handleButtonClick(i)}
//                                     >{i}</button>
//                                 </div>
//                             );
//                         } else if (i === 14) {
//                             buttons.push(
//                                 <div className="control-section-button without-button" id={`control-section-button-${i}`} key={i}>
//                                     <p>...</p>
//                                 </div>
//                             );
//                         } else {
//                             buttons.push(
//                                 <div className="control-section-button" id={`control-section-button-${numberofbuttons}`} key={numberofbuttons}>
//                                     <button
//                                         className={`button-${selectedButton === numberofbuttons ? 'selected' : ''}`}
//                                         onClick={() => handleButtonClick(numberofbuttons)}
//                                     >{numberofbuttons}</button>
//                                 </div>
//                             );
//                         }
//                     }
//                 } else if (lastsevenbuttons.includes(selectedButton)) {
//                     for (let i = numberofbuttons; i >= (numberofbuttons - 14); i--) {
//                         if (i > (numberofbuttons - 13)) {
//                             buttons.unshift(
//                                 <div className="control-section-button" id={`control-section-button-${i}`} key={i}>
//                                     <button
//                                         className={`button-${selectedButton === i ? 'selected' : ''}`}
//                                         onClick={() => handleButtonClick(i)}
//                                     >{i}</button>
//                                 </div>
//                             );
//                         } else if (i === (numberofbuttons - 13)) {
//                             buttons.unshift(
//                                 <div className="control-section-button without-button" id={`control-section-button-${i}`} key={i}>
//                                     <p>...</p>
//                                 </div>
//                             );
//                         } else {
//                             buttons.unshift(
//                                 <div className="control-section-button" id={`control-section-button-${1}`} key={1}>
//                                     <button
//                                         className={`button-${selectedButton === 1 ? 'selected' : ''}`}
//                                         onClick={() => handleButtonClick(1)}
//                                     >{1}</button>
//                                 </div>
//                             );
//                         }
//                     }
//                 } else {
//                     for (let i = 1; i <= 15; i++) {
//                         if (i === 1) {
//                             buttons.push(
//                                 <div className="control-section-button" id={`control-section-button-${1}`} key={1}>
//                                     <button
//                                         className={`button-${selectedButton === 1 ? 'selected' : ''}`}
//                                         onClick={() => handleButtonClick(1)}
//                                     >{1}</button>
//                                 </div>
//                             );
//                         } else if (i === 2) {
//                             buttons.push(
//                                 <div className="control-section-button without-button" id={`control-section-button-${i}`} key={i}>
//                                     <p>...</p>
//                                 </div>
//                             );
//                         } else if ((i <= 7 && i > 2) || (i <= 13 && i > 8)) {
//                             buttons.push(
//                                 <div className="control-section-button"
//                                     id={`control-section-button-${(selectedButton + i) - 8}`}
//                                     key={(selectedButton + i) - 8}>
//                                     <button
//                                         className={`button-${selectedButton === ((selectedButton + i) - 8) ? 'selected' : ''}`}
//                                         onClick={() => handleButtonClick((selectedButton + i) - 8)}
//                                     >{(selectedButton + i) - 8}</button>
//                                 </div>
//                             );
//                         } else if (i === 8) {
//                             buttons.push(
//                                 <div className="control-section-button"
//                                     id={`control-section-button-${selectedButton}`}
//                                     key={selectedButton}>
//                                     <button
//                                         className={"button-selected"}
//                                         onClick={() => handleButtonClick(selectedButton)}
//                                     >{selectedButton}</button>
//                                 </div>
//                             );
//                         } else if (i === 14) {
//                             buttons.push(
//                                 <div className="control-section-button without-button" id={`control-section-button-${i}`} key={i}>
//                                     <p>...</p>
//                                 </div>
//                             );
//                         } else {
//                             buttons.push(
//                                 <div className="control-section-button" id={`control-section-button-${numberofbuttons}`} key={numberofbuttons}>
//                                     <button
//                                         className={"button-"}
//                                         onClick={() => handleButtonClick(numberofbuttons)}
//                                     >{numberofbuttons}</button>
//                                 </div>
//                             );
//                         }
//                     }
//                 }
//             }
//             return buttons;
//         }

//         return (
//             <div className="control-section">
//                 <div className="control-section-buttons">
//                     <Makebuttons />
//                 </div>
//             </div>
//         );
//     }

//     function Productpagecomments() {
//         const currentComments = comments.slice(
//             ((selectedButton * 10) - 10),
//             ((selectedButton * 10))
//         );

//         return (
//             <div className="product-page-comments">
//                 <div className="product-page-comments-title">
//                     <p>{t('comments')} ({commentsnum})</p>
//                 </div>
//                 <div className="product-page-comments-container">
//                     {currentComments.length > 0 ? (
//                         currentComments.map((item, index) => (
//                             <div className="product-page-comment" key={`comment-${index + 1}`}>
//                                 <p className="product-page-comment-id">{item.id}</p>
//                                 <p className="product-page-comment-text">{item.text}</p>
//                             </div>
//                         ))
//                     ) : (
//                         <div className="no-comments">
//                             <p>{t('noComments')}</p>
//                         </div>
//                     )}
//                 </div>
//             </div>
//         );
//     }

//     return (
//         <div className="container-2" dir={direction} lang={currentLanguage}>
//             {/* عرض الإشعار المؤقت */}
//             {notification.message && (
//                 <div className={`notification ${notification.type}`}>
//                     {notification.message}
//                 </div>
//             )}

//             <div className="product-page-info">
//                 <div className="product-page-imgs">
//                     <div
//                         className="product-page-imgs-list"
//                         ref={imagesContainerRef}
//                         onMouseEnter={handleMouseEnter}       // ✅ للحاسوب: يوقف عند مرور الماوس
//                         onMouseLeave={handleMouseLeave}       // ✅ للحاسوب: يكمل عند ابتعاد الماوس
//                         onClick={handleToggleAnimation}       // ✅ للهاتف: ضغطة واحدة توقف، ضغطة أخرى تكمل
//                     >
//                         {displayImages.map((imgSrc, index) => (
//                             <div key={index} className="product-page-img">
//                                 <img
//                                     alt={t('productImageAlt', { number: index + 1 })}
//                                     src={imgSrc}
//                                     onError={(e) => {
//                                         e.target.onerror = null;
//                                         e.target.src = "default-image.jpg";
//                                     }}
//                                 />
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//                 <div className="breaking-line"></div>
//                 <div className="product-page-des">
//                     <div className="product-page-des-text">
//                         <div className="product-page-name-price">
//                             <div className="product-page-price">
//                                 <p>{currentPrice}</p>
//                             </div>
//                             <div className="product-page-name">
//                                 <p>{productData.name || t('productName')}</p>
//                             </div>
//                         </div>
//                         <div className="product-page-description" dir="auto">
//                             <p>{productData.description || t('noDescription')}</p>
//                         </div>
//                     </div>

//                     {hasColors && (
//                         <div className="product-page-color-size" dir="auto">
//                             <div className="product-page-color">
//                                 <p>{t('colors')}</p>
//                                 {productData.colors_sizes.map((item, index) => (
//                                     <div key={index} className="color-option">
//                                         <input
//                                             type="radio"
//                                             id={`color-${item.colorNameInArabic}`}
//                                             name="color"
//                                             value={item.colorNameInArabic}
//                                             onChange={() => handleColorChange(item)}
//                                             checked={selectedColor?.colorNameInArabic === item.colorNameInArabic}
//                                         />
//                                         <label
//                                             htmlFor={`color-${item.colorNameInArabic}`}
//                                             className="color-label"
//                                         >
//                                             {item.colorNameInArabic}
//                                         </label>
//                                     </div>
//                                 ))}
//                             </div>

//                             {hasSizes() && (
//                                 <div className="product-page-size">
//                                     <p>{t('sizes')}</p>
//                                     {selectedColor ? (
//                                         selectedColor.sizesAtColor && selectedColor.sizesAtColor.length > 0 ? (
//                                             selectedColor.sizesAtColor.map((size, index) => (
//                                                 <div key={index} className="size-option">
//                                                     <input
//                                                         type="radio"
//                                                         id={`size-${size}`}
//                                                         name="size"
//                                                         value={size}
//                                                         onChange={() => handleSizeChange(size)}
//                                                         checked={selectedSize === size}
//                                                     />
//                                                     <label htmlFor={`size-${size}`} className="size-label">
//                                                         {size}
//                                                     </label>
//                                                 </div>
//                                             ))
//                                         ) : (
//                                             <p>{t('noSizesForColor')}</p>
//                                         )
//                                     ) : (
//                                         <p>{t('selectColorFirst')}</p>
//                                     )}
//                                 </div>
//                             )}
//                         </div>
//                     )}
//                 </div>
//             </div>
//             <div className="product-page-add-product">
//                 <div className="product-page-add-product-button">
//                     <button
//                         disabled={isButtonDisabled()}
//                         className={`product-add-button ${isButtonDisabled() ? 'disabled' : 'enabled'}`}
//                         title={getButtonText()}
//                         onClick={addproductclicked}
//                     >
//                         {getButtonText()}
//                     </button>
//                 </div>
//             </div>
//             <Productpagecomments />
//             <Controlcomments />
//             <Addcomment productId={productData.id} />
//         </div>
//     );
// }



























































import "./productpageinfo.css";
import { useState, useEffect, useRef } from 'react';
import Addcomment from "./productpageaddcomment";
import { useTranslation } from '../../hooks/useTranslation';
import { useLanguage } from "../../context/LanguageContext";
import { getImageUrl } from '../../utils/imageUtils';

export default function Productpageinfo({ product, cartlist, setcartlist }) {
    const { t, currentLanguage, direction } = useTranslation();
    const { language } = useLanguage();

    // حالات التعليقات والأزرار
    const [comments, setComments] = useState([]);
    const [numberofbuttons, setNumberofbuttons] = useState(1);
    const [commentsnum, setCommentsnum] = useState(0);
    const [selectedButton, setSelectedButton] = useState(1);
    const [selectedColor, setSelectedColor] = useState(null);
    const [selectedSize, setSelectedSize] = useState(null);
    const [currentPrice, setCurrentPrice] = useState("0 " + t('currency'));
    const [isCurrentSizeValid, setIsCurrentSizeValid] = useState(false);

    // --- حالات السلايدر ---
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const intervalRef = useRef(null);
    const imagesContainerRef = useRef(null);

    // --- حالات المودال (عرض الصورة مكبرة) ---
    const [showModal, setShowModal] = useState(false);
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);
    const [scale, setScale] = useState(1);
    const modalImageRef = useRef(null);
    const [isTouching, setIsTouching] = useState(false);
    const [touchStartDist, setTouchStartDist] = useState(0);
    const [touchStartScale, setTouchStartScale] = useState(1);

    // حالات السحب (drag) للصورة المكبرة
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
    const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
    const [dragPos, setDragPos] = useState({ x: 0, y: 0 });

    // --- حالة الإشعارات ---
    const [notification, setNotification] = useState({ message: '', type: '' });
    const notificationTimeoutRef = useRef(null);

    const showNotification = (message, type = 'info') => {
        if (notificationTimeoutRef.current) {
            clearTimeout(notificationTimeoutRef.current);
        }
        setNotification({ message, type });
        notificationTimeoutRef.current = setTimeout(() => {
            setNotification({ message: '', type: '' });
        }, 3000);
    };

    const productData = product || {
        id: 1,
        name: t('productName'),
        global_price: t('price'),
        description: t('productDescription'),
        imgs: [],
        colors_sizes: [],
        comments: []
    };

    const hasColors = productData.colors_sizes && productData.colors_sizes.length > 0;

    const hasSizes = () => {
        if (!hasColors) return false;
        if (selectedColor) {
            return selectedColor.sizesAtColor && selectedColor.sizesAtColor.length > 0;
        }
        return productData.colors_sizes.some(color =>
            color.sizesAtColor && color.sizesAtColor.length > 0
        );
    };

    const productImages = Array.isArray(productData.images) ? productData.images : [];
    const allImages = productImages.length > 0
        ? productImages.map(img => getImageUrl(img))
        : ['default-image.jpg'];

    const totalImages = allImages.length;

    // --- دوال التنقل في السلايدر ---
    const goToNext = () => {
        if (totalImages === 0) return;
        setCurrentSlide((prev) => (prev + 1) % totalImages);
    };

    const goToPrev = () => {
        if (totalImages === 0) return;
        setCurrentSlide((prev) => (prev - 1 + totalImages) % totalImages);
    };

    const goToIndex = (index) => {
        if (index < 0 || index >= totalImages) return;
        setCurrentSlide(index);
    };

    // --- التشغيل التلقائي ---
    useEffect(() => {
        if (totalImages > 1 && !isPaused) {
            intervalRef.current = setInterval(goToNext, 4000);
        }
        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [totalImages, isPaused, goToNext]);

    const handlePause = () => setIsPaused(true);
    const handleResume = () => setIsPaused(false);

    // --- التحكم في إغلاق المودال عبر زر الرجوع ---
    useEffect(() => {
        if (showModal) {
            window.history.pushState(null, document.title, window.location.href);
            const handlePopState = () => {
                setShowModal(false);
            };
            window.addEventListener('popstate', handlePopState);
            return () => {
                window.removeEventListener('popstate', handlePopState);
            };
        }
    }, [showModal]);

    const handleImageClick = (index) => {
        setSelectedImageIndex(index);
        setScale(1);
        setDragPos({ x: 0, y: 0 }); // إعادة تعيين موضع السحب
        setShowModal(true);
    };

    // --- دوال التكبير/التصغير باستخدام عجلة الفأرة ---
    const handleWheel = (e) => {
        e.preventDefault();
        const delta = e.deltaY > 0 ? -0.1 : 0.1;
        setScale(prev => Math.min(Math.max(prev + delta, 0.5), 3));
        setDragPos({ x: 0, y: 0 });
    };

    // --- دوال التكبير/التصغير باستخدام اللمس (Pinch) ---
    const handleTouchStart = (e) => {
        if (e.touches.length === 2) {
            const touch1 = e.touches[0];
            const touch2 = e.touches[1];
            const dist = Math.hypot(touch1.clientX - touch2.clientX, touch1.clientY - touch2.clientY);
            setTouchStartDist(dist);
            setTouchStartScale(scale);
            setIsTouching(true);
        }
    };

    const handleTouchMove = (e) => {
        if (isTouching && e.touches.length === 2) {
            const touch1 = e.touches[0];
            const touch2 = e.touches[1];
            const dist = Math.hypot(touch1.clientX - touch2.clientX, touch1.clientY - touch2.clientY);
            const scaleChange = dist / touchStartDist;
            setScale(prev => Math.min(Math.max(touchStartScale * scaleChange, 0.5), 3));
            setDragPos({ x: 0, y: 0 });
        }
    };

    const handleTouchEnd = () => {
        setIsTouching(false);
    };

    // --- دوال السحب (Drag) للماوس ---
    const handleMouseDown = (e) => {
        if (scale > 1) {
            setIsDragging(true);
            setDragStart({ x: e.clientX, y: e.clientY });
            setDragOffset({ x: dragPos.x, y: dragPos.y });
            e.preventDefault();
        }
    };

    const handleMouseMove = (e) => {
        if (isDragging) {
            const dx = e.clientX - dragStart.x;
            const dy = e.clientY - dragStart.y;
            setDragPos({
                x: dragOffset.x + dx,
                y: dragOffset.y + dy
            });
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    // --- دوال السحب للشاشات اللمسية (لمسة واحدة) ---
    const handleTouchStartDrag = (e) => {
        if (scale > 1 && e.touches.length === 1) {
            const touch = e.touches[0];
            setIsDragging(true);
            setDragStart({ x: touch.clientX, y: touch.clientY });
            setDragOffset({ x: dragPos.x, y: dragPos.y });
        }
    };

    const handleTouchMoveDrag = (e) => {
        if (isDragging && e.touches.length === 1) {
            const touch = e.touches[0];
            const dx = touch.clientX - dragStart.x;
            const dy = touch.clientY - dragStart.y;
            setDragPos({
                x: dragOffset.x + dx,
                y: dragOffset.y + dy
            });
            e.preventDefault(); // منع سحب الصفحة بالكامل في الموبايل
        }
    };

    const handleTouchEndDrag = () => {
        setIsDragging(false);
    };

    // إعادة تعيين موضع السحب عند تغيير الصورة أو إغلاق المودال
    useEffect(() => {
        if (showModal) {
            setDragPos({ x: 0, y: 0 });
            setScale(1);
        }
    }, [selectedImageIndex, showModal]);

    // ========== باقي الدوال (بدون تغيير) ==========
    function addproductclicked() {
        if (hasColors && !selectedColor) {
            showNotification(t('selectColorFirst'), 'error');
            return;
        }
        if (hasSizes() && !selectedSize) {
            showNotification(t('selectSizeFirst'), 'error');
            return;
        }

        const newProduct = {
            id: product.id,
            name: product.name || productData.name,
            price: currentPrice,
            color: selectedColor ? selectedColor.colorNameInArabic : "",
            size: selectedSize || "",
            quantity: 1,
            uniqueId: `${product.id}_${selectedColor ? selectedColor.colorNameInArabic : 'no-color'}_${selectedSize || 'no-size'}`
        };

        const isProductAlreadyInCart = cartlist.some(item =>
            item.uniqueId === newProduct.uniqueId
        );

        if (isProductAlreadyInCart) {
            showNotification(t('productAlreadyInCart'), 'error');
            return;
        }

        setcartlist(prevCart => {
            const updatedCart = [...prevCart, newProduct];
            localStorage.setItem('cart', JSON.stringify(updatedCart));
            return updatedCart;
        });

        showNotification(t('productAddedToCart'), 'success');
    }

    useEffect(() => {
        if (productData.comments && Array.isArray(productData.comments)) {
            setComments(productData.comments);
            setCommentsnum(productData.comments.length);
            if (productData.comments.length % 10 === 0) {
                setNumberofbuttons(productData.comments.length / 10);
            } else {
                setNumberofbuttons(Math.ceil(productData.comments.length / 10));
            }
        }
    }, [productData]);

    useEffect(() => {
        if (hasColors && productData.colors_sizes[0].price) {
            setCurrentPrice(productData.colors_sizes[0].price);
        } else {
            setCurrentPrice(productData.global_price || "0 " + t('currency'));
        }
    }, [productData]);

    const handleColorChange = (colorItem) => {
        setSelectedColor(colorItem);
        if (colorItem.price) {
            setCurrentPrice(colorItem.price);
        } else if (productData.global_price) {
            setCurrentPrice(productData.global_price);
        }

        if (colorItem.sizesAtColor && colorItem.sizesAtColor.length > 0) {
            if (selectedSize && !colorItem.sizesAtColor.includes(selectedSize)) {
                setSelectedSize(null);
                setIsCurrentSizeValid(false);
            } else if (selectedSize && colorItem.sizesAtColor.includes(selectedSize)) {
                setIsCurrentSizeValid(true);
            }
        } else {
            setIsCurrentSizeValid(true);
            setSelectedSize(null);
        }
    };

    const handleSizeChange = (size) => {
        setSelectedSize(size);
        setIsCurrentSizeValid(true);
    };

    const isButtonDisabled = () => {
        if (hasColors && !selectedColor) return true;
        if (hasSizes() && !selectedSize) return true;
        if (selectedColor && selectedSize) {
            if (selectedColor.sizesAtColor && selectedColor.sizesAtColor.length > 0) {
                return !selectedColor.sizesAtColor.includes(selectedSize);
            }
        }
        return false;
    };

    const getButtonText = () => {
        if (hasColors && !selectedColor) return t('selectColorFirst');
        if (hasSizes() && !selectedSize) return t('selectSizeFirst');
        if (selectedColor && selectedSize && !isCurrentSizeValid) return t('invalidSizeForColor');
        return t('addToCartButton');
    };

    // دوال التعليقات والأزرار
    const firstsevenbuttons = [1, 2, 3, 4, 5, 6, 7];
    const lastsevenbuttons = [
        (numberofbuttons - 6),
        (numberofbuttons - 5),
        (numberofbuttons - 4),
        (numberofbuttons - 3),
        (numberofbuttons - 2),
        (numberofbuttons - 1),
        numberofbuttons
    ];

    function Controlcomments() {
        function Makebuttons() {
            const handleButtonClick = (buttonId) => {
                setSelectedButton(buttonId);
                window.localStorage.ProductPageBtnSelected = buttonId;
            };

            const buttons = [];

            if (numberofbuttons <= 15) {
                for (let i = 1; i <= numberofbuttons; i++) {
                    buttons.push(
                        <div className="control-section-button" id={`control-section-button-${i}`} key={i}>
                            <button
                                className={`button-${selectedButton === i ? 'selected' : ''}`}
                                onClick={() => handleButtonClick(i)}
                            >{i}</button>
                        </div>
                    );
                }
            } else {
                if (firstsevenbuttons.includes(selectedButton)) {
                    for (let i = 1; i <= 15; i++) {
                        if (i < 14) {
                            buttons.push(
                                <div className="control-section-button" id={`control-section-button-${i}`} key={i}>
                                    <button
                                        className={`button-${selectedButton === i ? 'selected' : ''}`}
                                        onClick={() => handleButtonClick(i)}
                                    >{i}</button>
                                </div>
                            );
                        } else if (i === 14) {
                            buttons.push(
                                <div className="control-section-button without-button" id={`control-section-button-${i}`} key={i}>
                                    <p>...</p>
                                </div>
                            );
                        } else {
                            buttons.push(
                                <div className="control-section-button" id={`control-section-button-${numberofbuttons}`} key={numberofbuttons}>
                                    <button
                                        className={`button-${selectedButton === numberofbuttons ? 'selected' : ''}`}
                                        onClick={() => handleButtonClick(numberofbuttons)}
                                    >{numberofbuttons}</button>
                                </div>
                            );
                        }
                    }
                } else if (lastsevenbuttons.includes(selectedButton)) {
                    for (let i = numberofbuttons; i >= (numberofbuttons - 14); i--) {
                        if (i > (numberofbuttons - 13)) {
                            buttons.unshift(
                                <div className="control-section-button" id={`control-section-button-${i}`} key={i}>
                                    <button
                                        className={`button-${selectedButton === i ? 'selected' : ''}`}
                                        onClick={() => handleButtonClick(i)}
                                    >{i}</button>
                                </div>
                            );
                        } else if (i === (numberofbuttons - 13)) {
                            buttons.unshift(
                                <div className="control-section-button without-button" id={`control-section-button-${i}`} key={i}>
                                    <p>...</p>
                                </div>
                            );
                        } else {
                            buttons.unshift(
                                <div className="control-section-button" id={`control-section-button-${1}`} key={1}>
                                    <button
                                        className={`button-${selectedButton === 1 ? 'selected' : ''}`}
                                        onClick={() => handleButtonClick(1)}
                                    >{1}</button>
                                </div>
                            );
                        }
                    }
                } else {
                    for (let i = 1; i <= 15; i++) {
                        if (i === 1) {
                            buttons.push(
                                <div className="control-section-button" id={`control-section-button-${1}`} key={1}>
                                    <button
                                        className={`button-${selectedButton === 1 ? 'selected' : ''}`}
                                        onClick={() => handleButtonClick(1)}
                                    >{1}</button>
                                </div>
                            );
                        } else if (i === 2) {
                            buttons.push(
                                <div className="control-section-button without-button" id={`control-section-button-${i}`} key={i}>
                                    <p>...</p>
                                </div>
                            );
                        } else if ((i <= 7 && i > 2) || (i <= 13 && i > 8)) {
                            buttons.push(
                                <div className="control-section-button"
                                    id={`control-section-button-${(selectedButton + i) - 8}`}
                                    key={(selectedButton + i) - 8}>
                                    <button
                                        className={`button-${selectedButton === ((selectedButton + i) - 8) ? 'selected' : ''}`}
                                        onClick={() => handleButtonClick((selectedButton + i) - 8)}
                                    >{(selectedButton + i) - 8}</button>
                                </div>
                            );
                        } else if (i === 8) {
                            buttons.push(
                                <div className="control-section-button"
                                    id={`control-section-button-${selectedButton}`}
                                    key={selectedButton}>
                                    <button
                                        className={"button-selected"}
                                        onClick={() => handleButtonClick(selectedButton)}
                                    >{selectedButton}</button>
                                </div>
                            );
                        } else if (i === 14) {
                            buttons.push(
                                <div className="control-section-button without-button" id={`control-section-button-${i}`} key={i}>
                                    <p>...</p>
                                </div>
                            );
                        } else {
                            buttons.push(
                                <div className="control-section-button" id={`control-section-button-${numberofbuttons}`} key={numberofbuttons}>
                                    <button
                                        className={"button-"}
                                        onClick={() => handleButtonClick(numberofbuttons)}
                                    >{numberofbuttons}</button>
                                </div>
                            );
                        }
                    }
                }
            }
            return buttons;
        }

        return (
            <div className="control-section">
                <div className="control-section-buttons">
                    <Makebuttons />
                </div>
            </div>
        );
    }

    function Productpagecomments() {
        const currentComments = comments.slice(
            ((selectedButton * 10) - 10),
            ((selectedButton * 10))
        );

        return (
            <div className="product-page-comments">
                <div className="product-page-comments-title">
                    <p>{t('comments')} ({commentsnum})</p>
                </div>
                <div className="product-page-comments-container">
                    {currentComments.length > 0 ? (
                        currentComments.map((item, index) => (
                            <div className="product-page-comment" key={`comment-${index + 1}`}>
                                <p className="product-page-comment-id">{item.id}</p>
                                <p className="product-page-comment-text">{item.text}</p>
                            </div>
                        ))
                    ) : (
                        <div className="no-comments">
                            <p>{t('noComments')}</p>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    // ========== JSX الرئيسي ==========
    return (
        <div className="container-2" dir={direction} lang={currentLanguage}>
            {notification.message && (
                <div className={`notification ${notification.type}`}>
                    {notification.message}
                </div>
            )}

            <div className="product-page-info">
                {/* الحل السحري: إضافة dir="ltr" لعزل السلايدر تماماً عن لغة الموقع */}
                <div className="product-page-imgs" dir="ltr">
                    <div
                        className="product-page-imgs-list"
                        ref={imagesContainerRef}
                        onMouseEnter={handlePause}
                        onMouseLeave={handleResume}
                        style={{
                            // الآن المعادلة بسيطة وثابتة دائماً لأن الحاوية LTR
                            transform: `translateX(-${currentSlide * 100}%)`,
                            transition: 'transform 0.5s ease'
                        }}
                    >
                        {allImages.map((imgSrc, index) => (
                            <div key={index} className="product-page-img" onClick={() => handleImageClick(index)}>
                                <img
                                    alt={t('productImageAlt', { number: index + 1 })}
                                    src={imgSrc}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = "default-image.jpg";
                                    }}
                                />
                            </div>
                        ))}
                    </div>

                    {/* النقاط */}
                    {totalImages > 1 && (
                        <div className="product-page-dots">
                            {allImages.map((_, idx) => (
                                <button
                                    key={idx}
                                    className={`product-page-dot ${idx === currentSlide ? 'active' : ''}`}
                                    onClick={() => goToIndex(idx)}
                                    aria-label={`انتقل إلى الصورة ${idx + 1}`}
                                />
                            ))}
                        </div>
                    )}

                    {/* أزرار التنقل - تظهر دائماً، ومواقعها مثبتة بقوة في CSS */}
                    {totalImages > 1 && (
                        <>
                            <button
                                className="product-page-arrow-left"
                                onClick={goToPrev}
                                onMouseEnter={handlePause}
                                onMouseLeave={handleResume}
                                aria-label="السابق"
                            >
                                <span>❮</span>
                            </button>
                            <button
                                className="product-page-arrow-right"
                                onClick={goToNext}
                                onMouseEnter={handlePause}
                                onMouseLeave={handleResume}
                                aria-label="التالي"
                            >
                                <span>❯</span>
                            </button>
                        </>
                    )}
                </div>

                <div className="breaking-line"></div>

                <div className="product-page-des">
                    <div className="product-page-des-text">
                        <div className="product-page-name-price">
                            <div className="product-page-price">
                                <p>{currentPrice}</p>
                            </div>
                            <div className="product-page-name">
                                <p>{productData.name || t('productName')}</p>
                            </div>
                        </div>
                        <div className="product-page-description" dir="auto">
                            <p>{productData.description || t('noDescription')}</p>
                        </div>
                    </div>

                    {hasColors && (
                        <div className="product-page-color-size" dir="auto">
                            <div className="product-page-color">
                                <p>{t('colors')}</p>
                                {productData.colors_sizes.map((item, index) => (
                                    <div key={index} className="color-option">
                                        <input
                                            type="radio"
                                            id={`color-${item.colorNameInArabic}`}
                                            name="color"
                                            value={item.colorNameInArabic}
                                            onChange={() => handleColorChange(item)}
                                            checked={selectedColor?.colorNameInArabic === item.colorNameInArabic}
                                        />
                                        <label
                                            htmlFor={`color-${item.colorNameInArabic}`}
                                            className="color-label"
                                        >
                                            {item.colorNameInArabic}
                                        </label>
                                    </div>
                                ))}
                            </div>

                            {hasSizes() && (
                                <div className="product-page-size">
                                    <p>{t('sizes')}</p>
                                    {selectedColor ? (
                                        selectedColor.sizesAtColor && selectedColor.sizesAtColor.length > 0 ? (
                                            selectedColor.sizesAtColor.map((size, index) => (
                                                <div key={index} className="size-option">
                                                    <input
                                                        type="radio"
                                                        id={`size-${size}`}
                                                        name="size"
                                                        value={size}
                                                        onChange={() => handleSizeChange(size)}
                                                        checked={selectedSize === size}
                                                    />
                                                    <label htmlFor={`size-${size}`} className="size-label">
                                                        {size}
                                                    </label>
                                                </div>
                                            ))
                                        ) : (
                                            <p>{t('noSizesForColor')}</p>
                                        )
                                    ) : (
                                        <p>{t('selectColorFirst')}</p>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* المودال مع دعم السحب والتكبير */}
            {showModal && (
                <div
                    className="image-modal-overlay"
                    onClick={(e) => {
                        if (e.target === e.currentTarget) setShowModal(false);
                    }}
                >
                    <div className="image-modal-content">
                        <div
                            className="modal-image-wrapper"
                            onWheel={handleWheel}
                            onTouchStart={(e) => {
                                handleTouchStart(e);
                                handleTouchStartDrag(e);
                            }}
                            onTouchMove={(e) => {
                                handleTouchMove(e);
                                handleTouchMoveDrag(e);
                            }}
                            onTouchEnd={(e) => {
                                handleTouchEnd();
                                handleTouchEndDrag();
                            }}
                            onMouseDown={handleMouseDown}
                            onMouseMove={handleMouseMove}
                            onMouseUp={handleMouseUp}
                            onMouseLeave={handleMouseUp}
                        >
                            <img
                                ref={modalImageRef}
                                src={allImages[selectedImageIndex]}
                                alt="صورة المنتج مكبرة"
                                className="modal-image"
                                style={{
                                    transform: `scale(${scale}) translate(${dragPos.x}px, ${dragPos.y}px)`,
                                    transition: isDragging ? 'none' : 'transform 0.1s ease',
                                    cursor: scale > 1 ? (isDragging ? 'grabbing' : 'grab') : 'default'
                                }}
                                draggable={false}
                            />
                        </div>
                    </div>
                </div>
            )}

            <div className="product-page-add-product">
                <div className="product-page-add-product-button">
                    <button
                        disabled={isButtonDisabled()}
                        className={`product-add-button ${isButtonDisabled() ? 'disabled' : 'enabled'}`}
                        title={getButtonText()}
                        onClick={addproductclicked}
                    >
                        {getButtonText()}
                    </button>
                </div>
            </div>

            <Productpagecomments />
            <Controlcomments />
            <Addcomment productId={productData.id} />
        </div>
    );
}